// removes the styles from original text and leave just plain text
// expects the selector ('#div' or '.class')
export const formatTextOnPaste = (selector) => {
    document.querySelector(selector).addEventListener('paste', (e) => {
        e.preventDefault();
        const text = e.clipboardData.getData('text/plain');
        document.execCommand('insertHTML', false, text);
    });
};
